import { HONOR_HALL_DEV_MOCK_PLAYER_NAMES } from './honorHallDevMockPlayerNames';

/**
 * Mock Honor Hall battle legends rows — descending win rate.
 * @returns {Array<{
 *   rank: number,
 *   username: string,
 *   win_rate: number,
 *   wins: number,
 *   losses: number,
 *   mmr: number,
 * }>}
 */
export function buildHonorHallBattleLegendsDevMockRows() {
  return HONOR_HALL_DEV_MOCK_PLAYER_NAMES.map((username, index) => {
    const winRate = Math.round((78.5 - index * 1.35) * 10) / 10;
    const wins = 52 - index * 2;
    const losses = Math.max(8, Math.round(wins * (100 - winRate) / winRate));
    const mmr = 2140 - index * 32;

    return {
      rank: index + 1,
      username,
      win_rate: winRate,
      wins,
      losses,
      mmr,
    };
  });
}
